import {
	BaseModal,
	ModalCloseCross,
	type BaseModalProps,
} from "@/components/ui/BaseModal";
import { Button } from "@/components/ui/button";
import { useId } from "react";
import { ProyectoForm } from "./Proyecto.form";
import { useApi } from "@/hooks/useApi";
import type { AddProyectoSchema } from "./Proyecto.schema";
import { useQueryClient } from "@tanstack/react-query";

interface NewProyectoModalProps extends BaseModalProps { }
export function NewProyectoModal(props: NewProyectoModalProps) {
	const formId = useId();
	const api = useApi();
	const queryClient = useQueryClient();
	const upsertion = api.useMutation("post", "/v1/Empresa/Proyectos/NewEntity", {
		onError: (error) => {
			if ("message" in error)
				console.error(error.message);
			else
				console.error(error.code);
			alert("Error al crear el proyecto");
		},
		onSuccess: () => {
			props.close();
		},
	});
	const onSubmit = (data: AddProyectoSchema) => {
		upsertion.mutate({
			body: {
				id: crypto.randomUUID(),
				...data,
			}
		}, {
			onSuccess: () => {
				void queryClient.invalidateQueries({ queryKey: ["get", "/v1/Empresa/Proyectos"] });
			},
		});
	};

	return (
		<BaseModal shown={props.shown} close={props.close} dialogSize="xl">
			<div className="modal-header">
				<h5 className="modal-title">Nuevo proyecto</h5>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body">
				<ProyectoForm onSubmit={onSubmit} id={formId} />
			</div>
			<div className="modal-footer">
				<Button variant="secondary" onClick={props.close}>
					Cancelar
				</Button>
				<Button
					variant="primary"
					disabled={upsertion.isPending}
					type="submit"
					form={formId}
				>
					Confirmar
				</Button>
			</div>
		</BaseModal>
	);
}
